// extracted by mini-css-extract-plugin
export default {"stripe":"ErrorStripe_stripe__IeSSL"};